import { createContext, useContext } from 'react'
import { BaseDateInput, BaseSelect, BaseTextInput, ElenchiManager, BaseGridLayout, formattaData, formattaLocalDate } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { ASSETS } from 'configuration/ConfigurazioneRotte'
import { LINK_FORM_PATENTE } from 'configuration/link'
import ConfigManager from 'components/config/ConfigManager'
import ListaLabelValoreSeparata from 'components/ui/ListaLabelValoreSeparata'
import useSchermoStretto from 'hook/useSchermoStretto'

const FormPatenteContext = createContext()

const CFG = LINK_FORM_PATENTE

const NOMI = {
  CATEGORIA: 'categoria',
  NUMERO: 'numero',
  RILASCIO_AUTORITA: 'rilascio_autorita',
  RILASCIO_ENTE: 'rilascio_ente',
  RILASCIO_DATA: 'rilascio_data',
  SCADENZA_DATA: 'scadenza_data',
  RILASCIO_PRIMADATA: 'rilascio_primadata',
}

FormPatente.DEFAULT_VALUES =  {
  categoria: '',
  numero: '',
  rilascio_autorita: '',
  rilascio_ente: '',
  rilascio_data: null,
  scadenza_data: null,
  rilascio_primadata: null,
}

FormPatente.trasformaValoriPerSalvataggio = function(valori) {
  const { rilascio_data, scadenza_data, rilascio_primadata } = valori
  return {
    ...valori,
    rilascio_data: formattaLocalDate(rilascio_data),
    scadenza_data: formattaLocalDate(scadenza_data),
    rilascio_primadata: formattaLocalDate(rilascio_primadata),
  }
}

export default function FormPatente(props) {
  const { prefissoNomi } = props

  const { txt, el } = useContext(FormPatenteContext)

  function n(nomeSenzaPrefisso) {
    return prefissoNomi ? `${prefissoNomi}.${nomeSenzaPrefisso}` : nomeSenzaPrefisso
  }

  return (
    <BaseGridLayout>
      <BaseGridLayout vertical>
        <ImmaginePatente num={1} />
        <ImmaginePatente num={2} />
        <ImmaginePatente num={3} />
      </BaseGridLayout>

      <BaseGridLayout vertical spacing={0}>
        <BaseTextInput
          label={txt(CFG.CATEGORIA)} name={n(NOMI.CATEGORIA)}
          required
        />
        <BaseTextInput
          label={txt(CFG.NUMERO)} name={n(NOMI.NUMERO)}
          required
        />
        <BaseDateInput
          label={txt(CFG.DATA_RILASCIO)} name={n(NOMI.RILASCIO_DATA)}
          required
          disabilitaToolbarCustom
          webComponentFix
        />
        <BaseSelect
          label={txt(CFG.ENTE_RILASCIO)} name={n(NOMI.RILASCIO_AUTORITA)}
          options={[{ value: '', label: '' }, ...el(ELENCHI.ENTI_PATENTE)]}
          required
        />
        <BaseTextInput
          label={txt(CFG.ENTE_RILASCIO_PROVINCIA)} name={n(NOMI.RILASCIO_ENTE)}
          required
        />
        <BaseDateInput
          label={txt(CFG.DATA_SCADENZA)} name={n(NOMI.SCADENZA_DATA)}
          required
          disabilitaToolbarCustom
          webComponentFix
        />
        <BaseDateInput
          label={txt(CFG.DATA_PRIMA_EMISSIONE)} name={n(NOMI.RILASCIO_PRIMADATA)}
          required
          disabilitaToolbarCustom
          webComponentFix
        />
      </BaseGridLayout>
    </BaseGridLayout>
  )
}



function ImmaginePatente(props) {
  const { num } = props

  const schermoStretto = useSchermoStretto()

  return (
    <img
      src={`${ASSETS}patente_${num}.jpg`}
      alt={`patente_${num}`}
      style={{ width: schermoStretto ? '100%' : 300 }}
    />
  )
}



export function FormPatenteProvider(props) {
  const { children } = props

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_LINK_FORM_PATENTE]}
      render={({ txt }) =>
        <ElenchiManager
          elenchi={[ELENCHI.ENTI_PATENTE]}
          render={el =>
            <FormPatenteContext.Provider value={{ txt, el }}>
              {children}
            </FormPatenteContext.Provider>
          }
        />
      }
    />
  )
}



export function RiassuntoPatente(props) {
  const { patente } = props
  const {
    categoria,
    numero,
    rilascio_autorita,
    rilascio_ente,
    rilascio_data,
    scadenza_data,
    rilascio_primadata,
  } = patente

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_LINK_FORM_PATENTE]}
      render={({ val }) =>
        <ElenchiManager
          elenchi={[ELENCHI.ENTI_PATENTE]}
          render={el => {
            const enti = el(ELENCHI.ENTI_PATENTE)
            const labelEnte = rilascio_autorita
              ? enti.find(({ value }) => value === rilascio_autorita)?.label ?? rilascio_autorita
              : ''
            return (
              <ListaLabelValoreSeparata
                lista={[
                  { label: val(CFG.NUMERO), valore: numero },
                  { label: val(CFG.CATEGORIA), valore: categoria },
                  { label: val(CFG.DATA_RILASCIO), valore: formattaData(rilascio_data) },
                  { label: val(CFG.ENTE_RILASCIO), valore: `${labelEnte} ${rilascio_ente}` },
                  { label: val(CFG.DATA_SCADENZA), valore: formattaData(scadenza_data) },
                  { label: val(CFG.DATA_PRIMA_EMISSIONE), valore: formattaData(rilascio_primadata) },
                ]}
              />
            )
          }}
        />
      }
    />
  )
}